// extracted by mini-css-extract-plugin
module.exports = {"body":"FABButton_body__2Y8bT"};